export interface IInitTest {
  session_id: string;
  test_parts: TTestPart;
  test_set: ITestSet;
  test_name: string;
}

interface ITestSet {
  set_id: string,
  set_name: string
}

export interface ITestPart {
  type: string;
  instruction: string;
  suggestion: string | null;
  questions: TQuestion;
  test_part_id: string;
}

export type TTestPart = ITestPart[];

export interface IQuestion {
  question: string;
  duration: number;
  order: number;
  audio: string;
}

type TQuestion = IQuestion[];

export const EXAM_TITLE_TYPE = {
  PART_ONE: 'Speaking Part I',
  PART_TWO: 'Speaking Part II',
  PART_THREE: 'Speaking Part III',
}

export enum ExamPartType {
  PART_ONE = 'PART_ONE',
  PART_TWO = 'PART_TWO',
  PART_THREE = 'PART_THREE'
}

export const STEP_TITLE_TYPE = {
  PART_ONE: 'Part 1',
  PART_TWO: 'Part 2',
  PART_THREE: 'Part 3',
}

export const EXAM_BODY_TYPE = {
  DESCRIBE: 'DESCRIBE',
  QUESTION_LIST: 'QUESTION_LIST',
  QUESTION: 'QUESTION',
  FINISH_QUESTION: 'FINISH_QUESTION',
}

export const SKILLS_RESULT: string[] = [
  'fluency', 'vocabulary', 'grammar', 'pronunciation',
]

export enum SkillsType {
  fluency = 'fluency',
  vocabulary = 'vocabulary',
  grammar = 'grammar',
  pronunciation = 'pronunciation',
}

export const EXAM_MODE_TYPE = {
  DEMO_TEST: 'DEMO_TEST',
  PRACTICE: 'PRACTICE',
}
